import React from "react";
import { VisualizationData } from "../models/VisualizationData";

const GraphContext = React.createContext<VisualizationData | undefined>(
  undefined
);
export { GraphContext };
